'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _UpOutlined = _interopRequireDefault(require('./lib/icons/UpOutlined'));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

var _default = _UpOutlined;
exports["default"] = _default;
module.exports = _default;